import { Stack } from '@mui/material';
import { Button, colors, Typography } from '@sweep-io/sweep-design';

export const InstructionsEmptyState = ({ onCreate }: { onCreate: () => void }) => {
  return (
    <Stack justifyContent="center" alignItems="center" height="100%" textAlign="center" gap={1}>
      <Typography variant="h4" color={colors.grey[800]}>
        No instructions yet
      </Typography>
      <Typography variant="h5" color={colors.grey[700]}>
        Define how the support agent should respond in specific cases.
      </Typography>
      <Stack pt={1}>
        <Button startIconName="Plus" size="small" onClick={onCreate}>
          Create your first
        </Button>
      </Stack>
    </Stack>
  );
};
